"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
let SummaryTable = class SummaryTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_MODEL = this.CONTROLLER.fieldsSummaryStep;
    }
    get fields() {
        return this.STEP_MODEL.data.fields;
    }
    fieldSetSizeUnit() {
        this.STEP_MODEL.data.fields.forEach((field) => {
            field.setAcreageUnit();
        });
    }
    findCrop(cropName) {
        const crop = this.CONTROLLER.crops.find((crop) => cropName === crop.name);
        return `/crop/pic/background/${crop === null || crop === void 0 ? void 0 : crop.icon}/Soil`;
    }
    parcelFillColor(field) {
        var _a;
        if (field.crop) {
            return `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50`;
        }
        else
            return '#eebb5450';
    }
    parcelStrokeColor(field) {
        var _a;
        if (field.crop) {
            return (_a = field.crop) === null || _a === void 0 ? void 0 : _a.color;
        }
        else
            return '#eebb54';
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 45, 45);
    }
};
SummaryTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { TableBmk: bmk_ui_framework_1.TableBmk, TableHeader: bmk_ui_framework_1.TableHeader, TableHeaderCell: bmk_ui_framework_1.TableHeaderCell, TableBody: bmk_ui_framework_1.TableBody, TableBodyRow: bmk_ui_framework_1.TableBodyRow, TableBodyCell: bmk_ui_framework_1.TableBodyCell, AlertTriangle: lucide_vue_next_1.AlertTriangle, ChevronsUpDown: lucide_vue_next_1.ChevronsUpDown }
    })
], SummaryTable);
exports.default = SummaryTable;
